module.exports = __webpack_public_path__ + "img/254.a1a3cee5.jpg";